import type { ClientStatus } from "@/types";

export interface ClientStatusStyle {
  bg: string;
  text: string;
  dot: string;
  border: string;
  label: string;
}

export const CLIENT_STATUS_CONFIG: Record<ClientStatus, ClientStatusStyle> = {
  ACTIVE: {
    bg: "bg-green-100",
    text: "text-green-700",
    dot: "bg-green-500",
    border: "border-green-200",
    label: "Attivo",
  },
  PROPOSAL: {
    bg: "bg-amber-100",
    text: "text-amber-700",
    dot: "bg-amber-500",
    border: "border-amber-200",
    label: "Proposta",
  },
  ARCHIVED: {
    bg: "bg-gray-200",
    text: "text-gray-600",
    dot: "bg-gray-400",
    border: "border-gray-300",
    label: "Archiviato",
  },
};

/** Statuses the inline badge dropdown is allowed to flip between.
 *  ARCHIVED is excluded — archiving is a destructive action handled by a
 *  dedicated menu item, not a casual click on a status pill. */
export const INLINE_SWITCHABLE_STATUSES: ClientStatus[] = ["ACTIVE", "PROPOSAL"];
